import React, { useEffect, useState } from 'react';
import './Menu.css';
import { Link, useLocation, useNavigate } from 'react-router-dom';

function Menu() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(Boolean(localStorage.getItem('access_token')));

  useEffect(() => {
    setIsLoggedIn(Boolean(localStorage.getItem('access_token')));
  }, [location.pathname]);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleLogout = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('username');
    setIsLoggedIn(false);
    setIsOpen(false);
    navigate('/');
  };

  return (
    <>
      <button className="hamburger-menu" onClick={toggleMenu}>
        ☰
      </button>
      <nav className={`sidebar ${isOpen ? 'open' : ''}`}>
        <button className="close-menu" onClick={toggleMenu}>
          ✕
        </button>
        <ul className="menu-list">
          <li className="menu-item"><Link to="/" className="menu-link" onClick={toggleMenu}>Home</Link></li>
          <li className="menu-item"><Link to="/about" className="menu-link" onClick={toggleMenu}>About</Link></li>
          <li className="menu-item"><Link to="/contact" className="menu-link" onClick={toggleMenu}>Contact</Link></li>
          {isLoggedIn ? (
            <>
              <li className="menu-item"><Link to="/userlogged" className="menu-link" aria-current={location.pathname === '/userlogged' ? 'page' : undefined} onClick={toggleMenu}>Moje konto</Link></li>
              <li className="menu-item"><button type="button" className="menu-link menu-action" onClick={handleLogout}>Logout</button></li>
            </>
          ) : (
            <li className="menu-item"><Link to="/login" className="menu-link" onClick={toggleMenu}>Login</Link></li>
          )}
        </ul>
      </nav>
    </>
  );
}

export default Menu;
